import { Meta, Title } from '@angular/platform-browser';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { services } from '../../services';
import { DivisionsService } from '../../../../../../shared/modules/core/services/divisions.service';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-wild-rift-solo-placements',
  templateUrl: './wild-rift-placements.component.html'
})
export class WildRiftPlacementsComponent {
  service = 'placements';
  availableServices = services['wild-rift'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'wild-rift',
    service: 'placements',
    type: 'solo',
    title: {
      en: 'Placements',
    },
    subtitle: {
      en: 'Guaranteed 70% Win Ratio (7 out of 10 Placements) in Solo or Duo Boosting',
      fr: 'Ratio de victoire garanti de 70 % (7 placements sur 10) en boosting solo ou duo',
      de: 'Garantierte 70% Gewinnquote (7 von 10 Platzierungen) im Solo oder Duo Boosting',
      pt: 'Percentagem de Vitória garantida de 70% (7 em 10 Placements) em Solo ou Duo Boosting',
      es: 'Porcentaje de victorias garantizado del 70% (7 de cada 10 clasificaciones) en Solo o Duo Boosting',
    },
    start: DivisionsService.getValueByRank('Gold IV', 'wild-rift'),
    desired: 10,
    serviceName: {
      en: 'Matches',
      fr: 'Parties',
      de: 'Matches',
      pt: 'Partidas',
      es: 'Partidas'
    },
    min: 1,
    max: 10
  }

  serviceFaqs = {
    en: [
      {
        question: "What Is A Placement Boosting Service?",
        answer: "Placement boosting is a form of Wild Rift elo boosting that assures a win rate of at least 70% in your ten placements matches. A different win ratio may apply for less than 10 placements."
      },
      {
        question: "What If I Dont Get At Least 70% Win Ratio?",
        answer: "Our typical placements win rate is above 86%, but if it drops below 70%, you will be compensated with net wins. The final win rate determines the total amount of net wins that are awarded."
      },
      {
        question: "Can I Still Purchase If I have Already Played One Or More Placements?",
        answer: "Indeed, you can. Simply select your past season rank and the number of remaining placements from the banner above."
      },
      {
        question: "Can I Dodge Placement Games?",
        answer: "While in champ select, dodging a placement game will simply result in a \"dodge penalty\" and won’t be marked as a loss."
      },
      {
        question: "What If I Transferred My Account From Other Server?",
        answer: "You will need to play 10 placements matches. When selecting your \"Last Season Rank\" you should instead select your \"rank before transfer\", as your MMR will not be significantly altered."
      },
      {
        question: "Can I Play With The Booster In Duo Queue Boosting?",
        answer: "Indeed, you can. To accomplish this, go to the order customization menu and select \"Duo\" before clicking \"Buy Boost Now\"."
      },
      {
        question: "Can I Choose My Preferred Champions/Roles And Summoner Spell Order?",
        answer: "Yes, you can. Click the \"Choose your Roles\" and \"Choose your Champions\" options in the order customization menu to make it happen."
      },
      {
        question: "Can I Play While The Order Is Active?",
        answer: "Yes, unless you want to queue in the same ranking mode as the bought service. Other than that, schedule it in the order chat with your booster."
      },
      {
        question: "Can I Request The Same Booster For A Future Purchase?",
        answer: "Yes! Click the heart icon inside the order dashboard to favorite a booster, then easily reassign them to your future orders."
      }
    ],
    fr: [
      {
        question: "Qu\'est-ce qu\'un Service de Boosting de Placement?",
        answer: "Le boosting de placement est une forme de boosting d\'elo Wild Rift qui assure un taux de victoire d\'au moins 70% sur vos dix parties de placement. Un taux de victoire différent peut s\'appliquer pour moins de 10 placements."
      },
      {
        question: "Que se passe-t-il si je n\'obtiens pas un ratio de victoire d\'au moins 70%?",
        answer: "Notre taux de victoire typique pour les placements est supérieur à 86 %, mais s\'il tombe en dessous de 70 %, vous serez compensé par des victoires nettes. Le taux de victoire final détermine le montant total des victoires nettes qui sont attribuées."
      },
      {
        question: "Puis-je encore acheter si j\'ai déjà joué une ou plusieurs parties de placements?",
        answer: "En effet, vous le pouvez. Il vous suffit de sélectionner votre rang d\'acte précédent et le nombre de parties de placements restants dans la bannière ci-dessus."
      },
      {
        question: "Puis-je esquiver les parties de placement?",
        answer: "Lors de la sélection des champions, l\'esquive d\'une partie de placement se traduira simplement par un \"pénalité d\'esquive\" et ne sera pas considérée comme une défaite."
      },
      {
        question: "Que se passe-t-il si je transfère mon compte sur un autre serveur?",
        answer: "Vous devrez jouer 10 parties de placement. Lorsque vous sélectionnez votre \"rang de la dernière saison\", vous devriez plutôt sélectionner votre \"rang avant le transfert\", car votre MMR ne sera pas modifié de manière significative."
      },
      {
        question: "Puis-je jouer avec le Booster en Boosting Duo?",
        answer: "En effet, vous pouvez le faire. Pour ce faire, allez dans le menu de personnalisation de la commande et sélectionnez \"Duo\" avant de cliquer sur \"Acheter Boost maintenant\"."
      },
      {
        question: "Puis-je choisir mes champions/rôles préférés et l\'ordre des sorts d\'invocateur?",
        answer: "Oui, vous le pouvez. Cliquez sur les boutons 'Choisissez vos Rôles' et 'Choisissez votre Champion' dans le menu de personnalisation de la commande pour le faire."
      },
      {
        question: "Puis-je jouer pendant que la commande est active?",
        answer: "Oui, sauf si vous voulez jouer dans le même mode classé que le service acheté. Dans le cas contraire, planifiez-le dans le chat de commande avec votre booster."
      },
      {
        question: "Puis-je demander le même booster pour un prochain achat?",
        answer: "Oui ! Cliquez sur l\'icône en forme de cœur dans le tableau de bord de commande pour ajouter un booster en favori, puis réassignez-le facilement à vos prochaines commandes."
      }
    ],
    de: [
      {
        question: "Was ist ein Placement Boosting Service?",
        answer: "Placement Boosting ist eine Form des Wild Rift Elo Boosting, bei der eine Gewinnrate von mindestens 70 % in deinen 10 Platzierungsspielen garantiert wird. Ein anderes Gewinnverhältnis kann bei weniger als 10 Platzierungen gelten."
      },
      {
        question: "Was ist, wenn ich nicht mindestens 70% Gewinnquote erreiche?",
        answer: "Unsere typische Platzierungs-Win-Rate liegt bei über 86 %, aber sollte sie unter 70 % fallen,wirst du mit Net Wins entschädigt. Die endgültige Gewinnrate bestimmt den Gesamtbetrag der Net Wins, die als Ladenkredite vergeben werden."
      },
      {
        question: "Kann ich noch kaufen, wenn ich bereits ein oder mehrere Platzierungsspiele gespielt habe?",
        answer: "Ja, das ist möglich. Wähle einfach deinen Rang aus der vorherigen Saison und die Anzahl der verbleibenden Platzierungsspiele aus."
      },
      {
        question: "Kann ich Platzierungsspiele ausweichen?",
        answer: "Während der Champion-Auswahl führt das Ausweichen eines Platzierungsspiels lediglich zu einer \"Dodge-Strafe\" und wird nicht als Niederlage gewertet."
      },
      {
        question: "Was ist, wenn ich mein Konto von einem anderen Server übertragen habe?",
        answer: "Du musst 10 Ranglistenspiele spielen. Wenn du deinen \"Last Season Rank\" auswählst, solltest du stattdessen deinen \"Rang vor der Übertragung\" wählen, da sich dein MMR nicht wesentlich ändert."
      },
      {
        question: "Kann ich mit dem Booster im Duo Queue Boosting spielen?",
        answer: "Ja, das kannst du. Gehe dazu in das Menü zur Bestellungsanpassung und wähle \"Duo\" aus, bevor du auf \"Boost Jetzt Kaufen\" klickst."
      },
      {
        question: " Kann ich meine bevorzugten Champions/Rollen und die Reihenfolge der Beschwörerzauber wählen?",
        answer: "Ja, das können Sie. Klicken Sie auf die Schaltflächen 'Wähle deine Rollen' und 'Wähle deinen Champion' im Bestell-Anpassungsmenü, um es zu tun."
      },
      {
        question: "Kann ich spielen, während die Bestellung aktiv ist?",
        answer: "Ja, es sei denn, du möchtest im gleichen Ranking-Modus wie der gekaufte Dienst spielen. Ansonsten planst du das mit deinem Booster im Auftragschat."
      },
      {
        question: "Kann ich denselben Booster auch für einen späteren Kauf anfordern?",
        answer: "Ja! Klicke im Bestell-Dashboard auf das Herzsymbol, um einen Booster zu deinen Favoriten hinzuzufügen, und weise ihn dann ganz einfach zukünftigen Bestellungen zu."
      }
    ],
    pt: [
      {
        question: "O Que É Um Serviço De Placements Boosting?",
        answer: "Placements Boosting é uma forma de Wild Rift Boosting que garante uma percentagem de vitória de pelo menos 70% nos teus 10 placements. Uma percentagem de vitória diferente pode ser aplicada para menos de 10 placements."
      },
      {
        question: "E Se Eu Não Conseguir Uma Percentagem de Vitória De Pelo Menos 70%?",
        answer: "A nossa percentagem de vitórias em placements é acima de 86%, mas se for abaixo de 70%, serás compensado com net wins. A percentagem final de vitórias determina o total de net wins concedidas."
      },
      {
        question: "Posso Comprar Mesmo Se Já Tiver Jogado Um Ou Mais Placements?",
        answer: "Sim. Basta selecionar o teu rank da season anterior e o número de placements restantes no banner acima."
      },
      {
        question: "Posso Dar Dodge A Jogos De Placements?",
        answer: "Enquanto estiveres em Champ Select, dar dodge a um jogo de placements apenas resultará numa \"dodge penalty\" e não será marcado como derrota."
      },
      {
        question: "E Se Eu Transferir A Minha Conta De Outro Servidor?",
        answer: "Precisas de fazer 10 placements. Ao selecionar o teu \"Rank da última season\", deves selecionar o \"rank antes da transferência\", pois o MMR não será significativamente alterado."
      },
      {
        question: "Posso Jogar com o Booster em Duo Queue?",
        answer: "Sim, podes. Para fazer isso, vê acima no menu de personalização do serviço e seleciona \"Duo\" antes de clicar em \"Comprar Boost Agora\".\" antes de clicar em \"Comprar Boost Agora\"."
      },
      {
        question: "Posso Escolher Os Meus Champions/Roles Favoritos E A Ordem Dos Summoner Spells?Champions/Roles e escolher a ordem dos Summoner Spells?",
        answer: "Sim, podes. Clica nas opções \"Escolhe os teus Roles\" e \"Escolhe os teus Champions\" no menu de personalização do serviço para o fazer."
      },
      {
        question: "Posso Jogar Enquanto O Serviço Está Activo?",
        answer: "Sim, a menos que queiras fazê-lo no mesmo modo de jogo do serviço comprado. Excepto isso, basta falares e agendares com o teu booster."
      },
      {
        question: "Posso escolher o mesmo Booster para uma compra futura?",
        answer: "Sim! Clica no ícone de coração dentro do painel do pedido para marcar um booster como favorito e depois escolhe-o facilmente nos teus próximos pedidos."
      }
    ],
    es: [
      {
        question: "¿Qué es un servicio de boosting de clasificación?",
        answer: "Boost de clasificación es una forma de elo boosting de Wild Rift que garantiza un porcentaje de victorias de al menos el 70% en tus diez partidas de clasificación. Se puede aplicar un ratio de victorias diferente para menos de 10 clasificaciones."
      },
      {
        question: "¿Qué pasa si no consigo al menos un 70% de porcentaje de victorias?",
        answer: "Nuestro porcentaje de ganancias de colocaciones típico es superior al 86%, pero si cae por debajo del 70%, se le compensará con ganancias netas. La tasa de ganancias final determina la cantidad total de ganancias netas que se conceden."
      },
      {
        question: "¿Puedo seguir comprando si ya he jugado una o más plazas?",
        answer: "Efectivamente. Solo tienes que seleccionar el puesto que ocupaste en el acto anterior y el número de colocaciones restantes en el banner de arriba."
      },
      {
        question: "¿Puedo esquivar los juegos de clasificación?",
        answer: "En la selección de campeón, si esquivas una partida de clasificación, el resultado será una \"penalización por esquivar\" y no se marcará como pérdida."
      },
      {
        question: "¿Qué pasa si he transferido mi cuenta desde otro servidor?",
        answer: "Tendrás que jugar 10 partidos de clasificación. Cuando selecciones tu \"rango de la última temporada\", deberás seleccionar tu \"rango antes de la transferencia\", ya que tu MMR no se verá alterado significativamente."
      },
      {
        question: "¿Puedo jugar con los boosters en Duo Queue Boosting?",
        answer: "Efectivamente, puede hacerlo. Para ello, ve al menú de personalización del pedido y selecciona \"Duo\" antes de hacer clic en \"Comprar Boost ahora\"."
      },
      {
        question: "¿Puedo elegir mis campeones/roles preferidos y el orden de los hechizos de invocador?",
        answer: "Sí, es posible. Haz clic en los botones \"Elige tus Roles y Campeones\" y \"Elige tus Hechizos de Invocador\" en el menú de personalización de la orden para hacerlo."
      },
      {
        question: "¿Puedo jugar mientras la orden está activa?",
        answer: "Sí, a menos que quieras hacer cola en el mismo modo de clasificación que el servicio comprado. Aparte de eso, prográmalo en el chat de órdenes con tu booster."
      },
      {
        question: "¿Puedo solicitar el mismo booster para una futura compra?",
        answer: "¡Sí! Haz clic en el ícono de corazón dentro del panel del pedido para añadir un booster a favoritos y así poder reasignarlo fácilmente en tus futuros pedidos."
      }
    ]
  }

  private page = {
    title: {
      en: "Wild Rift Boost - Placements Boosting for Wild Rift",
      fr: "Boost Wild Rift - Boosting de Placements sur Wild Rift",
      de: "Wild Rift Boost - Placements Boosting für Wild Rift",
      pt: "Wild Rift Boost - Boost de Colocações para Wild Rift",
      es: "Wild Rift Boost - Boosting de clasificaciones para Wild Rift",
    },
    metaDescription: {
      en: "Our Master+ boosters ensure that you have a win ratio of at least 70% in the most critical Wild Rift matches of the season",
      fr: "Nos boosters Master+ vous garantissent un ratio de victoire d\'au moins 70 % sur les parties de Wild Rift les plus critiques de la saison.",
      de: "Mit unseren Master+ Boostern ist sichergestellt, dass du in den kritischsten Wild Rift Matches der Saison eine Siegquote von mindestens 70% hast.",
      pt: "Nossos boosters Master+ garantem que você tenha uma taxa de vitória de pelo menos 70% nas partidas mais críticas de Wild Rift nesta temporada",
      es: "Nuestros boosters Master+ te garantizan un porcentaje de victorias de al menos el 70% en las partidas de Wild Rift más importantes de la temporada.",
    }
  }

  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private translationService: TranslationService, private cookie: CookieService) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }
    });

    title.setTitle(this.page.title[this.lang] || this.page.title['en']);

    meta.updateTag(
      {
        name: 'description',
        content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
      },
    );
  }
}